const React = require("react");

function EmojiHappyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = EmojiHappyIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/EmojiHappyIcon.js
 ** module id = 519
 ** module chunks = 0
 **/